import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=c2fcce1c&"
import script from "./TemplateItem.vue?vue&type=script&lang=js&"
export * from "./TemplateItem.vue?vue&type=script&lang=js&"
import style0 from "./TemplateItem.vue?vue&type=style&index=0&id=c2fcce1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports